import { useQuery } from "@tanstack/react-query";
import { fetchDashboardAnalytics } from "@/services/analytics.service";

export const useDashboardAnalyticsQuery = () => {
  return useQuery({
    queryKey: ["dashboard-analytics"],
    queryFn: fetchDashboardAnalytics,
  });
};
